import Vue from 'vue'
import Router from 'vue-router'
import navConf from '../nav.config.json'
// import guid from '../docs/giud.md'
// import install from '../docs/install.md'

Vue.use(Router)

let routes = []

Object.keys(navConf).forEach((header) => {
  routes = routes.concat(navConf[header])
})

let addComponent = (router) => {
  router.forEach((route) => {
    if (route.items) {
      addComponent(route.items)
      routes = routes.concat(route.items)
    } else {
      // if (route.type === 'pages') {
      //   route.component = r => require.ensure([], () =>
      //     r(require(`../pages/${route.name}.vue`)))
      //   return
      // }
      route.component = r => require.ensure([], () =>
        r(require(`../docs/${route.name}.md`)))
    }
  })
}
addComponent(routes)

routes.push({
  path: '/',
  redirect: '/giud'
})
// console.log(routes)
export default new Router({
  // mode: 'history',
  routes: routes
})



//////////////////
// WEBPACK FOOTER
// ./example/router/index.js
// module id = null
// module chunks = 